import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { throwApiError } from "./apiError";

export type ValidateMisdeliveryBolProResponse = {
  success: boolean;
};

export const validateMisdeliveryBolPro = async (
  misdeliveredBolPro: string | number,
): Promise<ValidateMisdeliveryBolProResponse> => {
  try {
    const response = await axios.get(
      `${getUrl(ApiType.MISDELIVERY_VALIDATE_BOL_PRO)}/${misdeliveredBolPro}`,
    );
    return response.data;
  } catch (error: unknown) {
    return throwApiError(
      error,
      "Unable to validate BOL PRO",
      // Backend uses response.data.errors[0].message for 400s.
      { badRequestOrder: "responseFirst" },
    );
  }
};
